import { HTMLAttributes } from 'react';
import cn from 'classnames';
import Link from 'next/link';
import styles from './healthcare-banner.module.css';

export interface BannerProps extends HTMLAttributes<HTMLDivElement> {
  text: string;
  href: string;
  btnLabel: string;
}

export default function HealthcareBanner({
  btnLabel,
  href,
  text,
  className,
  ...props
}: BannerProps) {
  return (
    <div className={cn(styles.banner, className)} {...props}>
      <p className={styles.banner_text}>{text}</p>
      <Link href={href} passHref prefetch={false}>
        <a className={styles.banner_btn}>{btnLabel}</a>
      </Link>
    </div>
  );
}
